import React, { useMemo } from "react";

import { CenterDetail } from "../../hooks/use-center";
import { Field } from "../forms/legacy/field";
import { StateSelector } from "../forms/legacy/state-selector";
import { FormRow, FormDividerRow } from "../forms/form-row";
import * as FormHelpers from "../forms/form-helpers";

export interface CenterInformationProps {
  center: CenterDetail;
}

const viewMode = "view" as const;

export const CenterInformation: React.FC<CenterInformationProps> = ({ center }) => {
  const display = useMemo(
    () => ({
      ...center,
      phoneAdvertised: FormHelpers.formatPhoneNumber(center?.phoneAdvertised ?? ""),
      phoneDirect: FormHelpers.formatPhoneNumber(center?.phoneDirect ?? ""),
      phoneTollfree: FormHelpers.formatPhoneNumber(center?.phoneTollfree ?? "")
    }),
    [center]
  );

  return (
    <div className="center-information-outer-container form">
      <FormRow>
        <Field
          value={display.name}
          mode={viewMode}
          label="Center Name"
          onValidate={FormHelpers.isValidRequiredString}
        />
      </FormRow>
      <FormRow>
        <Field
          value={display.line1}
          mode={viewMode}
          label="Address 1"
          onValidate={FormHelpers.isValidRequiredString}
          required
        />
      </FormRow>
      <FormRow>
        <Field
          value={display.line2}
          mode={viewMode}
          label="Address 2"
          onValidate={FormHelpers.isValidOptionalString}
        />
      </FormRow>
      <FormRow>
        <Field
          value={display.zipcode}
          mode={viewMode}
          label="ZIP"
          onValidate={FormHelpers.isValidZipcode}
          required
        />
        <Field
          value={display.city}
          mode={viewMode}
          label="City"
          onValidate={FormHelpers.isValidRequiredString}
          required
        />
        <StateSelector
          value={display.state}
          mode={viewMode}
          label="State"
          onValidate={FormHelpers.isValidRequiredString}
          required
        />
      </FormRow>
      <FormRow>
        <Field
          value={display.email}
          mode={viewMode}
          label="Email Address"
          onValidate={FormHelpers.isValidEmailAddress}
          required
        />
      </FormRow>
      <FormRow>
        <Field
          value={display.phoneDirect}
          mode={viewMode}
          label="Phone Direct"
          onValidate={FormHelpers.isValidOptionalPhoneNumber}
          required
        />
        <Field
          value={display.phoneAdvertised}
          mode={viewMode}
          label="Phone Advertised"
          onValidate={FormHelpers.isValidPhoneNumber}
          required
        />
      </FormRow>
      <FormRow>
        <Field
          value={display.url}
          mode={viewMode}
          label="Url"
          onValidate={FormHelpers.isValidRequiredString}
          required
        >
          {!!display.url && (
            <a href={display.url} rel="noreferrer" target="_blank" style={{ marginLeft: "10px" }}>
              <i className="fas fa-external-link-alt"></i>
            </a>
          )}
        </Field>
      </FormRow>
      <FormDividerRow show />
      <FormRow show>
        <Field
          value={display.latitude ?? ""}
          mode={viewMode}
          label="Latitude"
          onValidate={FormHelpers.isValidOptionalString}
        />
        <Field
          value={display.longitude ?? ""}
          mode={viewMode}
          label="Longitude"
          onValidate={FormHelpers.isValidOptionalString}
        />
      </FormRow>
    </div>
  );
};
